import * as React from "react";

const CancelIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41">
    <path
      fill="#171718"
      d="M14.4 27 13 25.6l5.6-5.6-5.6-5.6 1.4-1.4 5.6 5.6 5.6-5.6 1.4 1.4-5.6 5.6 5.6 5.6-1.4 1.4-5.6-5.6z"
    ></path>
  </svg>
);

export default CancelIconSVG;
